import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

type RefType = {
  current: HTMLElement | null;
};

/**
 * Animates the location details section
 */
export const animateLocationDetails = (
  detailsRef: RefType,
  containerRef: RefType,
  delay: number = 0
): ScrollTrigger | undefined => {
  if (!detailsRef.current || !containerRef.current) return;

  const detailsTrigger = ScrollTrigger.create({
    id: "location-details",
    trigger: containerRef.current,
    start: "top 70%",
    once: true,
  });

  gsap.fromTo(
    detailsRef.current,
    { opacity: 0, x: -30 },
    {
      opacity: 1,
      x: 0,
      duration: 0.7,
      delay,
      ease: "power3.out",
      scrollTrigger: detailsTrigger,
    }
  );

  return detailsTrigger;
};

/**
 * Animates the map section
 */
export const animateMap = (
  mapRef: RefType,
  containerRef: RefType,
  delay: number = 0.3
): ScrollTrigger | undefined => {
  if (!mapRef.current || !containerRef.current) return;

  const mapTrigger = ScrollTrigger.create({
    id: "location-map",
    trigger: containerRef.current,
    start: "top 70%",
    once: true,
  });

  gsap.fromTo(
    mapRef.current,
    { opacity: 0, x: 30 },
    {
      opacity: 1,
      x: 0,
      duration: 0.7,
      delay,
      ease: "power3.out",
      scrollTrigger: mapTrigger,
    }
  );

  return mapTrigger;
};

/**
 * Cleans up ScrollTrigger instances specific to this component
 */
export const cleanupScrollTriggers = (): void => {
  ScrollTrigger.getAll()
    .filter((trigger) => {
      const id = trigger.vars.id;
      return id && (id === "location-details" || id === "location-map");
    })
    .forEach((trigger) => trigger.kill());
};
